// ======================================================================
// File Name       : top
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/ActionTypes';

export function getNoticeForEnterprise(systemNotice) {
  return {
    type: ActionTypes.ENTERPRISE_NOTICE_LIST,
    systemNotice,
  };
}

export function getNoticeEnterpriseDetail(noticeEnterprise) {
  return {
    type: ActionTypes.ENTERPRISE_NOTICE_DETAIL,
    noticeEnterprise,
  };
}

export function getNoticeServiceDetail(noticeService) {
  return {
    type: ActionTypes.SERVICE_NOTICE_DETAIL,
    noticeService,
  };
}
